import {
	AnonymousStudentProfileSynced,
	AnonymousStudentProfileUpdated,
	AnonymousStudentServiceReady,
	EventType,
} from '@studyportals/anonymous-student-interfaces';
import { IStudent } from '@studyportals/studentdomain';
import { StudentField } from '@studyportals/studentdomain';
import { CopilotServiceApplication } from '@/application/copilot-service-application';
import { ISubscriber } from '@studyportals/event-aggregation-service-interface';
import globals from '@/utils/globals';
import { EventAggregationService } from '@/utils/event-aggregation-service';
export class ProfileDataCheckerPlugin
implements
	ISubscriber<AnonymousStudentProfileUpdated | AnonymousStudentServiceReady | AnonymousStudentProfileSynced> {

	public async initiate(): Promise<void> {
		await this.handleCompleteness();

		EventAggregationService.instance?.subscribeTo(
			EventType.AnonymousStudentProfileUpdated,
			this ,
			true
		);
		EventAggregationService.instance?.subscribeTo(
			EventType.AnonymousStudentServiceReady,
			this,
			true
		);

		EventAggregationService.instance?.subscribeTo(
			EventType.AnonymousStudentProfileSynced,
			this,
			true
		);
	}

	public notify(
		event: AnonymousStudentProfileUpdated | AnonymousStudentServiceReady | AnonymousStudentProfileSynced
	): void {

		switch (event.eventType as EventType) {
		case EventType.AnonymousStudentProfileSynced:
			void this.handleAnonymousStudentProfileSynced();
			break;
		case EventType.AnonymousStudentProfileUpdated:
			void this.handleAnonymousStudentProfileUpdated(event as AnonymousStudentProfileUpdated);
			break;
		case EventType.AnonymousStudentServiceReady:
			void this.handleAnonymousStudentServiceReady(event as AnonymousStudentServiceReady);
			break;
		}
	}

	private async handleAnonymousStudentProfileSynced(): Promise<void> {
		if (!globals.anonymousStudentService) return;

		const student = await globals.anonymousStudentService.getStudentData([
			StudentField.NATIONALITY_COUNTRY_ISO,
			StudentField.CURRENCY,
		]);

		this.updateStudentData(student);
		void this.handleCompleteness();
	}

	private async handleAnonymousStudentProfileUpdated(event: AnonymousStudentProfileUpdated): Promise<void> {
		const changes = event.changes;
		this.updateStudentData(changes);
		await this.handleCompleteness();
	}

	private async handleAnonymousStudentServiceReady(event: AnonymousStudentServiceReady): Promise<void> {
		globals.anonymousStudentService = event.anonymousStudentService;
		const student = await globals.anonymousStudentService.getStudentData([
			StudentField.NATIONALITY_COUNTRY_ISO,
			StudentField.CURRENCY,
		]);
		this.updateStudentData(student);
		await this.handleCompleteness();
	}

	private async handleCompleteness(): Promise<void> {
		const completeness = await globals.studentRepository.getCompleteness();

		if (completeness === 100) {
			CopilotServiceApplication.Store.mutations.setBestfitCompletness(true);
		}
	}

	private updateStudentData(student: IStudent): void {
		if (student[StudentField.NATIONALITY_COUNTRY_ISO]) {
			CopilotServiceApplication.Store.mutations.setUserNationalityCountryIso(student[StudentField.NATIONALITY_COUNTRY_ISO]);
		}

		if (student[StudentField.CURRENCY]) {
			CopilotServiceApplication.Store.mutations.setUserCurrency(student[StudentField.CURRENCY]);
		}
	}
}
